import {UserOPEEnum} from "../UserOPEEnum";
import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {ShareTargetResultDTO} from "../../dashboard/ShareDashboardCB";

class O {
  // Same DTO the BE returns for shareDashboard: newDashboardId and the widget counts stay unset
  // for a chart, which has no widgets of its own
  results!: ShareTargetResultDTO[];
  warningMessage?: string;
}

/**
 * I Inner Class
 */
class I {
  userMetricGroupId!: number;
  name!: string;
  targetUserIds!: number[];
}

/**
 * ShareUserMetricGroupCB class
 */
export class ShareUserMetricGroupCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(UserOPEEnum.ShareUserMetricGroup);
    this.i = new I();
    this.o = new O();
  }

}
